/*
 * Copyright (c) 2020. FINN Sp. z o.o.
 */
@file:UseContextualSerialization(LocalDate::class)

package pl.finn.forms.tw17

import io.kvision.types.LocalDate
import kotlinx.serialization.Serializable
import kotlinx.serialization.UseContextualSerialization
import pl.finn.forms.Zalacznik
import pl.finn.forms.tw1.DocumentTreeNode


@Serializable
data class Tw17Form(
  val namespaceURI: String? = null,
  val kodUrzedu: DocumentTreeNode = DocumentTreeNode(),
  val uuid: DocumentTreeNode = DocumentTreeNode(),
  val nazwaPliku: DocumentTreeNode = DocumentTreeNode(),
  val data: DocumentTreeNode = DocumentTreeNode(),
  val kodFormularza: DocumentTreeNode = DocumentTreeNode(),
  val kodSystemowy: DocumentTreeNode = DocumentTreeNode(),
  val wersjaSchemy: DocumentTreeNode = DocumentTreeNode(),
  val sygnatura: DocumentTreeNode = DocumentTreeNode(),
  val dataWystawienia: DocumentTreeNode = DocumentTreeNode(),
  val rodzajDokumentu: DocumentTreeNode = DocumentTreeNode(),
  val dtw: DocumentTreeNode = DocumentTreeNode(value = "false"),
  val bezPrzeksztalcenia: DocumentTreeNode = DocumentTreeNode(),
  val numerZarzadzaniaZabezpieczenia: DocumentTreeNode = DocumentTreeNode(),
  val dataZarzadzaniaZabezpieczenia: DocumentTreeNode = DocumentTreeNode(),
  val zarzadzenieZabezpieczenia: DocumentTreeNode = DocumentTreeNode(value = "false"),
  val numerRefZarzadzenieZabezpieczenia: DocumentTreeNode = DocumentTreeNode(),
  //val pierwszyDokumentWSprawie: DocumentTreeNode = DocumentTreeNode(value = "false"),
  val pierwszyDokumentWSprawieRadio: DocumentTreeNode = DocumentTreeNode(),
  val numerRefPierwszegoDokumentu: DocumentTreeNode = DocumentTreeNode(),
  val rodzajPierwszegoDokumentu: DocumentTreeNode = DocumentTreeNode(),
  val pierwotnyTW: DocumentTreeNode = DocumentTreeNode(),
  val numerPorzadkowy: DocumentTreeNode = DocumentTreeNode(),
  val celWydania: DocumentTreeNode = DocumentTreeNode(),
  val dataWydaniaDalszegoTW: DocumentTreeNode = DocumentTreeNode(),
  val dotyczyDokumentu: DocumentTreeNode = DocumentTreeNode(),
  val kosztyEgzekucyjne: DocumentTreeNode = DocumentTreeNode(),
  val adnotacja: DocumentTreeNode = DocumentTreeNode(value = "false"),
  val dataWystawieniaPonownegoTW: DocumentTreeNode = DocumentTreeNode(),
  val nazwaWierzyciela: DocumentTreeNode = DocumentTreeNode(),
  val sygnaturaPostanowienia: DocumentTreeNode = DocumentTreeNode(),
  val dataWydaniaPostanowienia: DocumentTreeNode = DocumentTreeNode(),
  val rodzajUtraconegoDokumentu: DocumentTreeNode = DocumentTreeNode(),
  val zobowiazany: DocumentTreeNode = DocumentTreeNode(),
  val zobowiazanyOsobaFizyczna: OsobaFizyczna = OsobaFizyczna(),
  val zobowiazanyOsobaFizycznaZobowiazanyPierwotny: DocumentTreeNode = DocumentTreeNode(),
  val zobowiazanyOsobaFizycznaZobowiazanyPierwotnyData: ArrayList<ZobowiazanyPierwotny> = arrayListOf(ZobowiazanyPierwotny()),
  val zobowiazanyOsobaNiefizyczna: OsobaNiefizyczna = OsobaNiefizyczna(),
  val zobowiazanyOsobaNiefizycznaZobowiazanyPierwotny: DocumentTreeNode = DocumentTreeNode(),
  val zobowiazanyOsobaNiefizycznaZobowiazanyPierwotnyData: ArrayList<ZobowiazanyPierwotny> = arrayListOf(ZobowiazanyPierwotny()),
  val zobowiazanyMalzonkowie: ArrayList<OsobaFizyczna> = arrayListOf(OsobaFizyczna(), OsobaFizyczna()),
  val zobowiazanyMalzonkowieOdpowiedzialnosc: DocumentTreeNode = DocumentTreeNode(),
  val zobowiazanyMalzonekZobowiazanyPierwotny: DocumentTreeNode = DocumentTreeNode(),
  val zobowiazanyMalzonekZobowiazanyPierwotnyData: ArrayList<ZobowiazanyPierwotny> = arrayListOf(ZobowiazanyPierwotny()),
  val zobowiazanyJednostka: OsobaNiefizyczna = OsobaNiefizyczna(),
  val zobowiazanyJednostkaWspolnicy: DocumentTreeNode = DocumentTreeNode(),
  val zobowiazanyJednostkaWspolnicyData: ArrayList<Wspolnik> = arrayListOf(Wspolnik()),
  val zobowiazanyJednostkaZobowiazanyPierwotny: DocumentTreeNode = DocumentTreeNode(),
  val zobowiazanyJednostkaZobowiazanyPierwotnyData: ArrayList<ZobowiazanyPierwotny> = arrayListOf(ZobowiazanyPierwotny()),
  val zobowiazanyPodmiot: PodmiotWOrganizacji = PodmiotWOrganizacji(),
  val zobowiazanyPodmiotZobowiazanyPierwotny: DocumentTreeNode = DocumentTreeNode(),
  val zobowiazanyPodmiotZobowiazanyPierwotnyData: ArrayList<ZobowiazanyPierwotny> = arrayListOf(ZobowiazanyPierwotny()),
  val zobowiazanyPrzedsiebiorstwoWSpadku: PrzedsiebiorstwoWSpadku = PrzedsiebiorstwoWSpadku(),
  val naleznoscAktNormatywny: DocumentTreeNode = DocumentTreeNode(),
  val naleznoscRodzajNaleznosci: DocumentTreeNode = DocumentTreeNode(),
  val naleznoscRodzajNaleznosciKodPodstawyPrawnej: DocumentTreeNode = DocumentTreeNode(),
  val naleznoscRodzajNaleznosciRodzaj: DocumentTreeNode = DocumentTreeNode(),
  val naleznoscObowiazek: DocumentTreeNode = DocumentTreeNode(),
  val naleznoscObowiazekZMocyPrawa: DocumentTreeNode = DocumentTreeNode(),
  val naleznoscObowiazekInnyDokument: DocumentTreeNode = DocumentTreeNode(),
  val naleznoscObowiazekOrzeczenie: DocumentTreeNode = DocumentTreeNode(),
  val naleznoscOrzeczenieDataWydania: DocumentTreeNode = DocumentTreeNode(),
  val naleznoscZabezpieczenia: NaleznoscZabezpieczenia = NaleznoscZabezpieczenia(),
  val naleznoscDoreczenia: DocumentTreeNode = DocumentTreeNode(),
  val naleznoscDoreczeniaBrakUpomnienia: DocumentTreeNode = DocumentTreeNode(),
  val naleznoscDoreczeniaKosztyUpomnienia: DocumentTreeNode = DocumentTreeNode(),
  val naleznoscPowiadomienieDataDoreczenia: DocumentTreeNode = DocumentTreeNode(),
  val naleznoscDoreczeniaDataDoreczenia: ArrayList<DocumentTreeNode> = arrayListOf(DocumentTreeNode()),
  val naleznoscOgranOdpowiedzialny: Podmiot = Podmiot(),
  val naleznoscOgranUdzielajacyInformacji: DocumentTreeNode = DocumentTreeNode(value = "false"),
  val naleznoscOgranUdzielajacyInformacjiData: Podmiot = Podmiot(),
  val zobowiazanie: DocumentTreeNode = DocumentTreeNode(),
  val zobowiazanieBrakOdsetekPozycja: ArrayList<Pozycja> = arrayListOf(Pozycja()),
  val zobowiazanieOdsetkiRodzaj: DocumentTreeNode = DocumentTreeNode(),
  val zobowiazanieOdsetkiPozycja: ArrayList<Pozycja> = arrayListOf(Pozycja()),
  val zobowiazanieOdsetki: DocumentTreeNode = DocumentTreeNode(),
  val zobowiazanieOdsetkiStawka: DocumentTreeNode = DocumentTreeNode(),
  val zobowiazanieOdsetkiPodwyzszonaStawka: DocumentTreeNode = DocumentTreeNode(),
  val innaPodstawaPrawna: DocumentTreeNode = DocumentTreeNode(),
  val odpowiedzialnoscObejmujeMajatekWspolny: DocumentTreeNode = DocumentTreeNode(),
  val obowiazekScisleZwiazanyZeZobowiazanym: DocumentTreeNode = DocumentTreeNode(),
  val wierzycielKodWierzyciela: DocumentTreeNode = DocumentTreeNode(),
  val wierzycielNazwa: DocumentTreeNode = DocumentTreeNode(),
  val wierzycieWniosekOgezekucjeKieruje:  DocumentTreeNode = DocumentTreeNode(),
  val wierzycielAdres: AdresPolski = AdresPolski(),
  val wierzycielOrganAdres: AdresPolski = AdresPolski(),
  val wierzycielNip: DocumentTreeNode = DocumentTreeNode(),
  val wierzycielRegon: DocumentTreeNode = DocumentTreeNode(),
  val wierzycielNrTelefonu: DocumentTreeNode = DocumentTreeNode(),
  val wierzycielNrTelefonuWew: DocumentTreeNode = DocumentTreeNode(),
  val wierzycielEmail: DocumentTreeNode = DocumentTreeNode(),
  val wierzycielAdresEDorenczen: DocumentTreeNode = DocumentTreeNode(),
  val wierzycielOrganNazwa: DocumentTreeNode = DocumentTreeNode(),
  val wierzycielOrganAdresPolski: AdresPolski = AdresPolski(),
  val wierzycielOrganNip: DocumentTreeNode = DocumentTreeNode(),
  val wierzycielOrganRegon: DocumentTreeNode = DocumentTreeNode(),
  val wierzycielOrganNrTelefonu: DocumentTreeNode = DocumentTreeNode(),
  val wierzycielOrganNrTelefonuWew: DocumentTreeNode = DocumentTreeNode(),
  val wierzycielOrganEmail: DocumentTreeNode = DocumentTreeNode(),
  val wierzycielOrganAdresEDorenczen: DocumentTreeNode = DocumentTreeNode(),
  val beneficjentNalezyPrzekazac: DocumentTreeNode = DocumentTreeNode(),
  val beneficjentNazwa: DocumentTreeNode = DocumentTreeNode(),
  val beneficjentAdres: AdresPolski = AdresPolski(),
  val beneficjentNrRachunkuPl: DocumentTreeNode = DocumentTreeNode(),
  val beneficjentNrRachunkuPlInnyOrgan: DocumentTreeNode = DocumentTreeNode(),
  val wniosekOWszczecie: DocumentTreeNode = DocumentTreeNode(),
  val osobaUpowaznionaImie: DocumentTreeNode = DocumentTreeNode(),
  val osobaUpowaznionaNazwisko: DocumentTreeNode = DocumentTreeNode(),
  val osobaUpowaznionaStanowisko: DocumentTreeNode = DocumentTreeNode(),
  val zakresInfomacji: DocumentTreeNode = DocumentTreeNode(),
  val skladnikMajatku: ArrayList<DocumentTreeNode> = arrayListOf(DocumentTreeNode()),
  val adresDluznikaZobowiazanegoAdres: DocumentTreeNode = DocumentTreeNode(),
  val adresDluznikaZobowiazanegoAdresData: Adres = Adres(),
  val adresDluznikaZobowiazanegoNrTelefonu: DocumentTreeNode = DocumentTreeNode(),
  val adresDluznikaZobowiazanegoNrWew: DocumentTreeNode = DocumentTreeNode(),
  val dataNumerWnioskuDataWyslania: DocumentTreeNode = DocumentTreeNode(),
  val dataNumerWnioskuNrRefWniosku: DocumentTreeNode = DocumentTreeNode(),
  val postanowienieUmorzeniaDataWydania: DocumentTreeNode = DocumentTreeNode(),
  val postanowienieUmorzeniaNrPostanowienia: DocumentTreeNode = DocumentTreeNode(),
  val postanowienieUmorzeniaTrescInformacji: DocumentTreeNode = DocumentTreeNode(),
  val reprezentantTypPrzedstawiciela: DocumentTreeNode = DocumentTreeNode(),
  val reprezentantImie: DocumentTreeNode = DocumentTreeNode(),
  val reprezentantNazwisko: DocumentTreeNode = DocumentTreeNode(),
  val reprezentantAdres: DocumentTreeNode = DocumentTreeNode(),
  val reprezentantAdresData: Adres = Adres(),
  val zarzadcaWSpadkuImie: DocumentTreeNode = DocumentTreeNode(),
  val zarzadcaWSpadkuNazwisko: DocumentTreeNode = DocumentTreeNode(),
  val zarzadcaWSpadkuAdres: DocumentTreeNode = DocumentTreeNode(),
  val zarzadcaWSpadkuAdresData: Adres = Adres(),
  val daneZmarlegoPrzedsiebiorcyImie: DocumentTreeNode = DocumentTreeNode(),
  val daneZmarlegoPrzedsiebiorcyNazwisko: DocumentTreeNode = DocumentTreeNode(),
  val daneZmarlegoPrzedsiebiorcyPesel: DocumentTreeNode = DocumentTreeNode(),
  val majatekZobowiazanegoNaTerenieOE: ArrayList<DocumentTreeNode> = arrayListOf(DocumentTreeNode()),
  val innaOkolicznosc: ArrayList<DocumentTreeNode> = arrayListOf(DocumentTreeNode()),
  val zalacznikiMalzonek: ZalacznikiMalzonek = ZalacznikiMalzonek(),
  val zalacznikPodmitZobowiazany: ArrayList<ZalacznikPodmitZobowiazany> = arrayListOf(ZalacznikPodmitZobowiazany()),
  val zalacznikPodmiotMajatkowy: ArrayList<ZalacznikPodmiotMajatkowy> = arrayListOf(ZalacznikPodmiotMajatkowy())
)

@Serializable
data class WierzycielInfo(
  val nip: DocumentTreeNode = DocumentTreeNode(),
  val regon: DocumentTreeNode = DocumentTreeNode(),
  val nrTelefonu: DocumentTreeNode = DocumentTreeNode(),
  val nrTelefonuWew: DocumentTreeNode = DocumentTreeNode(),
  val email: DocumentTreeNode = DocumentTreeNode(),
  //val skrytkaEPuap: DocumentTreeNode = DocumentTreeNode(),
  val adresEDorenczen: DocumentTreeNode = DocumentTreeNode()
)

@Serializable
data class ZalacznikiMalzonek(
  val imie: DocumentTreeNode = DocumentTreeNode(),
  val nazwisko: DocumentTreeNode = DocumentTreeNode(),
  val adres: DocumentTreeNode = DocumentTreeNode(),
  val adresData: Adres = Adres(),
  val admId: DocumentTreeNode = DocumentTreeNode(),
  val nip: DocumentTreeNode = DocumentTreeNode(),
  val pesel: DocumentTreeNode = DocumentTreeNode(),
  val oswiadczenieWierzyciela: DocumentTreeNode = DocumentTreeNode(),
  val posiadaNrId: DocumentTreeNode = DocumentTreeNode(value = "false"),
  val nrIdentyfikacyjny: NrIdentyfikacyjny = NrIdentyfikacyjny()
)

//@Serializable
//data class ZalacznikiOsobaFizyczna(
//  val imie: DocumentTreeNode = DocumentTreeNode(),
//  val nazwisko: DocumentTreeNode = DocumentTreeNode(),
//  val adres: DocumentTreeNode = DocumentTreeNode(),
//  val adresData: Adres = Adres(),
//  val admId: DocumentTreeNode = DocumentTreeNode(),
//  val nip: DocumentTreeNode = DocumentTreeNode(),
//  val pesel: DocumentTreeNode = DocumentTreeNode(),
//  val regon: DocumentTreeNode = DocumentTreeNode(),
//  val oswiadczenieWierzyciela: DocumentTreeNode = DocumentTreeNode(),
//  val posiadaNrId: DocumentTreeNode = DocumentTreeNode(value = "false"),
//  val nrIdentyfikacyjny: NrIdentyfikacyjny = NrIdentyfikacyjny()
//)
//
//@Serializable
//data class ZalacznikiOsobaNieFizyczna(
//  val nazwa: DocumentTreeNode = DocumentTreeNode(),
//  val adres: DocumentTreeNode = DocumentTreeNode(),
//  val adresData: Adres = Adres(),
//  val admId: DocumentTreeNode = DocumentTreeNode(),
//  val nip: DocumentTreeNode = DocumentTreeNode(),
//  val regon: DocumentTreeNode = DocumentTreeNode(),
//  val krs1: DocumentTreeNode = DocumentTreeNode(),
//  val oswiadczenieWierzyciela: DocumentTreeNode = DocumentTreeNode(),
//  val posiadaNrId: DocumentTreeNode = DocumentTreeNode(value = "false"),
//  val nrIdentyfikacyjny: NrIdentyfikacyjny = NrIdentyfikacyjny()
//)

@Serializable
data class ZalacznikPodmitZobowiazany(
  val rodzaj: DocumentTreeNode = DocumentTreeNode(),
  val osobaFizyczna: OsobaFizyczna = OsobaFizyczna(),
  val osobaNiefizyczna: OsobaNiefizyczna = OsobaNiefizyczna()
)

@Serializable
data class ZalacznikPodmiotMajatkowy(
  val rodzaj: DocumentTreeNode = DocumentTreeNode(),
  val osobaFizyczna: OsobaFizyczna = OsobaFizyczna(),
  val osobaNiefizyczna: OsobaNiefizyczna = OsobaNiefizyczna(),
  val majatekList: ArrayList<DocumentTreeNode> = arrayListOf(DocumentTreeNode()),
)

@Serializable
data class OsobaFizyczna(
  val imie: DocumentTreeNode = DocumentTreeNode(),
  val nazwisko: DocumentTreeNode = DocumentTreeNode(),
  val imieMatki: DocumentTreeNode = DocumentTreeNode(),
  val imieOjca: DocumentTreeNode = DocumentTreeNode(),
  val admId: DocumentTreeNode = DocumentTreeNode(),
  val nip: DocumentTreeNode = DocumentTreeNode(),
  val pesel: DocumentTreeNode = DocumentTreeNode(),
  val regon: DocumentTreeNode = DocumentTreeNode(),
  val nrInny: DocumentTreeNode = DocumentTreeNode(),
  val posiadaNrId: DocumentTreeNode = DocumentTreeNode(value = "false"),
  val nrIdentyfikacyjny: NrIdentyfikacyjny = NrIdentyfikacyjny(),
  val oswiadczenieWierzyciela: DocumentTreeNode = DocumentTreeNode(),
  val adres: DocumentTreeNode = DocumentTreeNode(),
  val adresData: Adres = Adres(),
  //val nrTelefonu: DocumentTreeNode = DocumentTreeNode(),
  //val email: DocumentTreeNode = DocumentTreeNode(),
  val dataUrodzenia: DocumentTreeNode = DocumentTreeNode(),
  val odpowiedzialnosc: DocumentTreeNode = DocumentTreeNode(),
)

/*@Serializable
data class OsobaFizycznaWspolnik(
  val imie: DocumentTreeNode = DocumentTreeNode(),
  val nazwisko: DocumentTreeNode = DocumentTreeNode(),
  val admId: DocumentTreeNode = DocumentTreeNode(),
  val nip1: DocumentTreeNode = DocumentTreeNode(),
  val pesel1: DocumentTreeNode = DocumentTreeNode(),
  val pesel2: DocumentTreeNode = DocumentTreeNode(),
  val nip2: DocumentTreeNode = DocumentTreeNode(),
  val regon1: DocumentTreeNode = DocumentTreeNode(),
  val regon2: DocumentTreeNode = DocumentTreeNode(),
  val oswiadczenieWierzyciela: DocumentTreeNode = DocumentTreeNode(),
  val adres: DocumentTreeNode = DocumentTreeNode(),
  val adresData: Adres = Adres(),
  val nrTelefonu: DocumentTreeNode = DocumentTreeNode(),
  val email: DocumentTreeNode = DocumentTreeNode(),
  val odpowiedzialnosc: DocumentTreeNode = DocumentTreeNode(),
)*/

@Serializable
data class NrIdentyfikacyjny(
  val innyNrId: DocumentTreeNode = DocumentTreeNode(),
  val rodzaj: DocumentTreeNode = DocumentTreeNode()
)

@Serializable
data class OsobaNiefizyczna(
  //val wSpadku: DocumentTreeNode = DocumentTreeNode(),
  val nazwa: DocumentTreeNode = DocumentTreeNode(),
  val admId: DocumentTreeNode = DocumentTreeNode(),
  val regon: DocumentTreeNode = DocumentTreeNode(),
  val nip: DocumentTreeNode = DocumentTreeNode(),
  val krs: DocumentTreeNode = DocumentTreeNode(),
  val oswiadczenie: DocumentTreeNode = DocumentTreeNode(),
  val nrInny: DocumentTreeNode = DocumentTreeNode(),
  val posiadaNrId: DocumentTreeNode = DocumentTreeNode(value = "false"),
  val nrIdentyfikacyjny: NrIdentyfikacyjny = NrIdentyfikacyjny(),
  val adres: DocumentTreeNode = DocumentTreeNode(),
  val adresData: Adres = Adres(),
  //val nrTelefonu: DocumentTreeNode = DocumentTreeNode(),
  //val email: DocumentTreeNode = DocumentTreeNode(),
  val odpowiedzialnosc: DocumentTreeNode = DocumentTreeNode(),
  )

/*@Serializable
data class OsobaNiefizycznaWspolnik(
  val nazwa: DocumentTreeNode = DocumentTreeNode(),
  val admId: DocumentTreeNode = DocumentTreeNode(),
  val regon1: DocumentTreeNode = DocumentTreeNode(),
  val nip1: DocumentTreeNode = DocumentTreeNode(),
  val nip2: DocumentTreeNode = DocumentTreeNode(),
  val regon2: DocumentTreeNode = DocumentTreeNode(),
  val krs1: DocumentTreeNode = DocumentTreeNode(),
  val oswiadczenie: DocumentTreeNode = DocumentTreeNode(),
  val adres: DocumentTreeNode = DocumentTreeNode(),
  val adresData: Adres = Adres(),
  val nrTelefonu: DocumentTreeNode = DocumentTreeNode(),
  val email: DocumentTreeNode = DocumentTreeNode(),
  val odpowiedzialnosc: DocumentTreeNode = DocumentTreeNode(),
)*/

@Serializable
data class PodmiotWOrganizacji(
  val nazwa: DocumentTreeNode = DocumentTreeNode(),
  val adres: DocumentTreeNode = DocumentTreeNode(),
  val adresData: Adres = Adres(),
  //val nrTelefonu: DocumentTreeNode = DocumentTreeNode(),
  //val email: DocumentTreeNode = DocumentTreeNode(),
  val odpowiedzialnosc: DocumentTreeNode = DocumentTreeNode(),
)

@Serializable
data class PodmiotWOrganizacjiPierwotny(
  val nazwa: DocumentTreeNode = DocumentTreeNode()
)

@Serializable
data class PrzedsiebiorstwoWSpadku(
  val wSpadku: DocumentTreeNode = DocumentTreeNode(),
  val imie: DocumentTreeNode = DocumentTreeNode(),
  val nazwisko: DocumentTreeNode = DocumentTreeNode(),
  val nazwa: DocumentTreeNode = DocumentTreeNode(),
  val admId: DocumentTreeNode = DocumentTreeNode(),
  val regon: DocumentTreeNode = DocumentTreeNode(),
  val nip: DocumentTreeNode = DocumentTreeNode(),
  val oswiadczenie: DocumentTreeNode = DocumentTreeNode(),
  val adres: DocumentTreeNode = DocumentTreeNode(),
  val adresData: Adres = Adres(),
  //val nrTelefonu: DocumentTreeNode = DocumentTreeNode(),
  //val email: DocumentTreeNode = DocumentTreeNode(),
  val odpowiedzialnosc: DocumentTreeNode = DocumentTreeNode(),
)

@Serializable
data class Podmiot(
  val nazwa: DocumentTreeNode = DocumentTreeNode(),
  val adres: DocumentTreeNode = DocumentTreeNode(),
  val adresData: Adres = Adres(),
  val nrTelefonu: DocumentTreeNode = DocumentTreeNode(),
  val nrTelefonuWew: DocumentTreeNode = DocumentTreeNode(),
  val email: DocumentTreeNode = DocumentTreeNode(),
  val skrytkaEPuap: DocumentTreeNode = DocumentTreeNode(),
  val adresEdorecznen: DocumentTreeNode = DocumentTreeNode()
)

@Serializable
data class Wspolnik(
  val partner: DocumentTreeNode = DocumentTreeNode(),
  val osobaFizyczna: OsobaFizyczna = OsobaFizyczna(),
  val osobaNiefizyczna: OsobaNiefizyczna = OsobaNiefizyczna(),
)

@Serializable
data class Adres(
  val adresPolski: AdresPolski = AdresPolski(),
  val adresZagranicznyKodKraju: DocumentTreeNode = DocumentTreeNode(),
  val adresZagranicznyKodPocztowy: DocumentTreeNode = DocumentTreeNode(),
  val adresZagranicznyMiejscowosc: DocumentTreeNode = DocumentTreeNode(),
  val adresZagranicznyUlica: DocumentTreeNode = DocumentTreeNode(),
  val adresZagranicznyNrDomu: DocumentTreeNode = DocumentTreeNode(),
  val adresZagranicznyNrLokalu: DocumentTreeNode = DocumentTreeNode(),
)

@Serializable
data class AdresPolski(
  val kodKraju: DocumentTreeNode = DocumentTreeNode(),
  val wojewodztwo: DocumentTreeNode = DocumentTreeNode(),
  val powiat: DocumentTreeNode = DocumentTreeNode(),
  val gmina: DocumentTreeNode = DocumentTreeNode(),
  val miejscowosc: DocumentTreeNode = DocumentTreeNode(),
  val ulica: DocumentTreeNode = DocumentTreeNode(),
  val nrDomu: DocumentTreeNode = DocumentTreeNode(),
  val nrLokalu: DocumentTreeNode = DocumentTreeNode(),
  val kodPocztowy: DocumentTreeNode = DocumentTreeNode(),
)

@Serializable
data class ZobowiazanyPierwotny(
  val obligated: DocumentTreeNode = DocumentTreeNode(),
  val osobaFizyczna: OsobaFizyczna = OsobaFizyczna(),
  val malzonkowie: ArrayList<OsobaFizyczna> = arrayListOf(OsobaFizyczna(), OsobaFizyczna()),
  val osobaPrawna: OsobaNiefizyczna = OsobaNiefizyczna(),
  val osobaJednostka: OsobaNiefizyczna = OsobaNiefizyczna(),
  val podmiot: PodmiotWOrganizacjiPierwotny = PodmiotWOrganizacjiPierwotny()
)

@Serializable
data class Pozycja(
  val kwota: DocumentTreeNode = DocumentTreeNode(),
  val odsetkiDniaOd: DocumentTreeNode = DocumentTreeNode(),
  val kwotaOdsetek: DocumentTreeNode = DocumentTreeNode(),
  val dochodzicDniaDo: DocumentTreeNode = DocumentTreeNode(),
  val okresDniaOd: DocumentTreeNode = DocumentTreeNode(),
  val okresDniaDo: DocumentTreeNode = DocumentTreeNode(),
  val podstawaPrawnaPierwszenstwa: DocumentTreeNode = DocumentTreeNode(),
)

@Serializable
data class Tw17FormData(
  val form: Tw17Form,
  val zalaczniki: List<Zalacznik>,
  val url: String,
  val token: String?
)

@Serializable
data class NaleznoscZabezpieczenia(
  val posiadaZabezpieczenie: DocumentTreeNode = DocumentTreeNode(value = "false"),
  val hipotekaZastaw: DocumentTreeNode = DocumentTreeNode(),
  val dataPowstania: DocumentTreeNode = DocumentTreeNode()
)

fun getRandomString(): String {
  val allowedChars = ('a'..'z') + ('A'..'Z')
  return (1..8)
    .map { allowedChars.random() }
    .joinToString("")
}

@Serializable
enum class TypPerson {
  ZOBOWIAZANY, WSPOLNIK, ZALACZNIK_OSOBA
}


